/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Full_Fuzzy_Grizzly_BendInputs */

const fr_full_fuzzy_grizzly_bend = /** @type {(inputs: Full_Fuzzy_Grizzly_BendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimé`)
};

/**

* @param {Full_Fuzzy_Grizzly_BendInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const full_fuzzy_grizzly_bend = /** @type {((inputs?: Full_Fuzzy_Grizzly_BendInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Full_Fuzzy_Grizzly_BendInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_full_fuzzy_grizzly_bend(inputs)
});